import React from 'react';
import { motion } from 'framer-motion';
export function TestimonialsV2() {
  const testimonials = [{
    title: 'Schnell den richtigen Maler gefunden!',
    text: 'Innerhalb von 24 Stunden hatten wir 4 Offerten – die Preise lagen bis zu 30% auseinander. Wir haben den besten Maler zum fairen Preis gefunden. Reibungslos und absolut empfehlenswert.',
    author: 'Sandra B.'
  }, {
    title: 'Faire Preise dank Vergleich',
    text: 'Endlich keine endlose Suche bei Google mehr. Ofri hat uns drei top Maler vorgeschlagen, wir konnten die Angebote vergleichen und der ausgewählte Maler war pünktlich und sauber.',
    author: 'Daniela K.'
  }];
  return <section className="py-14 sm:py-20 bg-white" data-id="element-57">
      <div className="max-w-5xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-58">
        <motion.h2 initial={{
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true
      }} transition={{
        duration: 0.5
      }} className="text-3xl sm:text-4xl font-bold text-gray-900 text-center mb-10 sm:mb-14 tracking-tight" data-id="element-59">
          Das sagen unsere Kunden
        </motion.h2>

        <div className="grid md:grid-cols-2 gap-10 sm:gap-12 md:gap-16" data-id="element-60">
          {testimonials.map((t, i) => <motion.div key={t.author} initial={{
          opacity: 0,
          y: 12
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true
        }} transition={{
          duration: 0.4,
          delay: i * 0.1
        }} data-id="element-61">
              <h3 className="text-gray-900 font-bold mb-4" data-id="element-62">"{t.title}"</h3>
              <p className="text-gray-700 italic leading-relaxed mb-6" data-id="element-63">
                {t.text}
              </p>
              <p className="font-semibold text-gray-900" data-id="element-64">– {t.author}</p>
            </motion.div>)}
        </div>
      </div>
    </section>;
}